import { VPathKey } from 'lib/history';

export interface IModulePath {
  [x: string]: VPathKey[];
}

export enum VModuleKey {
  consent = 'consent',
  addhaarXml = 'addhaarXml',
  addhaar = 'addhaar',
  pan = 'pan',
  check = 'check',
  main = 'main',
  precall = 'precall',
  ktp = 'ktp',
  card = 'card',
}
